module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card no-shadow"
  }, [_c('div', {
    staticClass: "card-title cursor-pointer",
    on: {
      "click": function($event) {
        _vm.$emit('focus')
      }
    }
  }, [_c('div', {
    staticClass: "text-primary text-bold"
  }, [_vm._v(_vm._s(_vm.info.name))]), _vm._v(" "), _c('small', {
    staticClass: "text-primary"
  }, [_vm._v("\n      " + _vm._s(_vm.schoolType[0]) + "  ·  " + _vm._s(_vm.schoolType[1]) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "card-details",
    on: {
      "click": function($event) {
        _vm.$emit('focus')
      }
    }
  }, [(_vm.uniqueCcas.length > 0) ? _c('div', {
    staticClass: "unique-title text-negative text-italic"
  }, [_vm._v("\n      Unique CCAs:\n    ")]) : _vm._e(), _vm._v(" "), (_vm.uniqueCcas.length > 0) ? _c('div', {
    staticClass: "unique-content"
  }, _vm._l((_vm.uniqueCcas), function(cca) {
    return _c('span', [_c('small', {
      staticClass: "cca-name"
    }, [_vm._v(_vm._s(cca.name))]), _c('small', {
      staticClass: "dot"
    }, [_vm._v("·")])])
  })) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card-actions"
  }, [_c('span', {
    staticClass: "text-primary cursor-pointer action-details",
    on: {
      "click": function($event) {
        _vm.$emit('focus')
      }
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('span', {
    staticClass: "cursor-pointer action-bookmark",
    class: _vm.bookmarked ? 'text-bookmark' : 'text-primary',
    on: {
      "click": function($event) {
        _vm.$emit('bookmark')
      }
    }
  }, [_c('small', [_c('img', {
    attrs: {
      "src": _vm.bookmarked ? '/assets/Star_Green.svg' : '/assets/Star_Blue.svg'
    }
  }), _vm._v("Bookmark\n      ")])]), _vm._v(" "), (_vm.travelTime) ? _c('span', {
    staticClass: "action-traveltime"
  }, [_c('small', {
    staticClass: "text-primary"
  }, [_c('img', {
    attrs: {
      "src": "/assets/Car.svg"
    }
  }), _vm._v(_vm._s(_vm.travelTime))])]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "auto"
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('small', [_c('img', {
    attrs: {
      "src": "/assets/More_Details.svg"
    }
  }), _vm._v(" Details")])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6a87fcbc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6a87fcbc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ListView/ListCard.vue
// module id = 857
// module chunks = 0